// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"2edfc816","585":"1488ba57","766":"1488ba57","891":"6c3aa803","950":"1488ba57"}[chunkId] + ".chunk.css";
};